export default {
  descriptionColor: Styles.color.grey.one,
  disclaimerTextCssColor: Styles.color.grey.one,
  emptyStateBodyColor: Styles.color.grey.one,
  headingTextTransform: 'uppercase' as const,
  pCssColor: Styles.color.grey.one,
  textColor: Styles.color.grey.one,
};
